import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useFetchData,
  useMemo,
  useSearch,
  UsersIcon,
  useToggle,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import MultiSearch from "./components/MultiSearch";
import { TableActions } from "./components/TableOptions";
import { donorsColumns } from "./components/tableColumns";
import { donorToggleActive, getDonors } from "./utils/api";
import { excelHeaderCellsName, searchValues } from "./utils/options";

const Index = () => {
  const links = [{ name: "المتبرعين", link: "" }];

  const { search, updateSearch } = useSearch(searchValues);

  const { data, setData, isLoading, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getDonors,
      params: [search.values],
    });

  const { active } = useToggle(setData, donorToggleActive);

  // Append the actions column to the static donorsColumns
  const columns = useMemo(
    () => [
      ...donorsColumns,
      {
        id: "actions",
        header: "",
        size: 120,
        cell: ({ row }) => (
          <TableActions row={row.original} toggleActive={active} />
        ),
      },
    ],
    [active],
  );

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="المتبرعين"
          title="المتبرعين"
          count={pg.rows}
          icon={UsersIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />
          <DownloadExcel
            headerCellsName={excelHeaderCellsName}
            fetch={getDonors}
            search={search.values}
            length={data?.length}
          />
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
